import { render } from "./SubtitleSection.vue?vue&type=template&id=0eb1909a&scoped=true"
import script from "./SubtitleSection.vue?vue&type=script&lang=js"
export * from "./SubtitleSection.vue?vue&type=script&lang=js"

import "./SubtitleSection.vue?vue&type=style&index=0&id=0eb1909a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb1909a"]])

export default __exports__